import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const api = '/api/';

interface VoorkeurenOptions {
  size?: string;
  sort?: string;
  offset?: string;
  soort?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VoorkeurenResource {
  public constructor(private httpClient: HttpClient) {}

  public getVoorkeuren(options: VoorkeurenOptions = {}): Observable<any> {
    return this.httpClient.get<any>(api + 'voorkeuren', { params: options as any });
  }
}
